// Abuse reports — POST /v1/reports (abuse-and-trust §5; backend
// `internal/abuse`). The report carries metadata-first references
// (conversation + event + reported account + categorical reason); the
// reporter's identity is taken from the JWT server-side. `cited_content` is
// only forwarded when the reporter explicitly consents.

import { NetworkError,post } from './api';

export type ReportReason =
  | 'spam'
  | 'harassment'
  | 'scam'
  | 'csam'
  | 'self_harm'
  | 'violence'
  | 'other';

export interface PostReportParams {
  /** Base64url id of the reported AppEvent (optional — empty when reporting a
   *  whole conversation rather than a single message). */
  readonly eventId: string;
  /** Base64url id of the conversation. */
  readonly conversationId: string;
  /** Base64url BE account id of the reported user. */
  readonly reportedAccountId: string;
  readonly reason: ReportReason;
  /** Optional content cited by the reporter; only sent (and only stored) when
   *  `consent` is true. */
  readonly citedContent?: Record<string, unknown> | undefined;
  readonly consent: boolean;
}

export interface ReportResponse {
  readonly report_id: string;
}

/**
 * File an abuse report. Returns the server-minted report id (base64url).
 * Throws {@link NetworkError} on a non-2xx response.
 */
export async function postReport(params: PostReportParams): Promise<ReportResponse> {
  const body: Record<string, unknown> = {
    // event_id is optional — only send it when reporting a specific message.
    ...(params.eventId.length > 0 ? { event_id: params.eventId } : {}),
    conversation_id: params.conversationId,
    reported_account_id: params.reportedAccountId,
    reason: params.reason,
    consent_to_include_content: params.consent,
    cited_content:
      params.consent && params.citedContent !== undefined ? params.citedContent : null,
  };
  return post<ReportResponse>('/v1/reports', body);
}

export { NetworkError };
